/**
 * Procedure Categories and Procedures for MD in Forensic Medicine students
 * Extracted with strict evidence from official NMC PDF
 */
export const FORENSIC_MEDICINE_PROCEDURES = {
  "Autopsy & Postmortem Procedures": [
    "Medico-Legal Autopsy / Postmortem Examination",
    "Exhumation Procedure & Sample Collection",
    "Examination & Identification of Human Skeletal Remains (Bones)",
    "Examination of Wet Specimens, Clothing, and Weapons",
  ],
  "Clinical Forensic & Medico-Legal Examinations": [
    "Medico-Legal Examination of Sexual Offences (Accused and Victim)",
    "Medico-Legal Examination of Alcohol, Drug, and Poisoning Suspects",
    "Age Estimation Examination & Certification",
    "Medico-Legal Examination of Injured Persons (Hurt Report)",
    "Collection, Preservation, and Dispatch of Trace Evidence & Biological Samples",
  ],
};

export const FORENSIC_MEDICINE_CATEGORIES = Object.keys(FORENSIC_MEDICINE_PROCEDURES);

export const isMDInForensicMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("forensic") || d.includes("fmt");
};
